import type { TOC } from '@ember/component/template-only';
import ModalInviteUsers from 'lumen/components/settings/users/modals/modal-invite-users';
import UsersTable from 'lumen/components/settings/users/tables/users-table';
import type MarketSettingsUsersController from 'lumen/controllers/market/settings/users';

interface MarketSettingsUsersSignature {
  Args: {
    controller: MarketSettingsUsersController;
  };
}

const MarketSettingsUsers: TOC<MarketSettingsUsersSignature> = <template>
  <UsersTable
    @displaySearchValue={{@controller.displaySearchValue}}
    @isAdmin={{@controller.isAdmin}}
    @isAllSubscriptions={{@controller.isAllSubscriptions}}
    @isLoading={{@controller.isLoading}}
    @isLoadingMore={{@controller.isLoadingMore}}
    @managedUserCount={{@controller.totalRecords}}
    @managedUsers={{@controller.accumulatedManagedUsers}}
    @onBulkApply={{@controller.applyBulkChanges}}
    @onBulkDelete={{@controller.bulkDeleteUsers}}
    @onDeleteUser={{@controller.deleteUser}}
    @onInvite={{@controller.openInviteModal}}
    @onLoadMore={{@controller.loadMoreTask.perform}}
    @onProductChange={{@controller.updateProduct}}
    @onRemoveFromAllSubscriptions={{@controller.removeUserFromAllSubscriptions}}
    @onRoleChange={{@controller.updateRole}}
    @onSave={{@controller.saveChanges}}
    @onSearchChange={{@controller.updateSearch}}
    @onSortChange={{@controller.onUpdateSorts}}
    @onSubscriptionChange={{@controller.updateSubscription}}
    @product={{@controller.product}}
    @role={{@controller.role}}
    @selectedSubscription={{@controller.selectedSubscription}}
    @sorts={{@controller.sorts}}
    @totalUserCount={{@controller.totalRecords}}
    @users={{@controller.accumulatedUsers}}
  />

  {{#if @controller.isInviteModalVisible}}
    <ModalInviteUsers
      @onClose={{@controller.closeInviteModal}}
      @onInvite={{@controller.inviteUsers}}
      @subscription={{@controller.selectedSubscription}}
    />
  {{/if}}

  {{outlet}}
</template>;

export default MarketSettingsUsers;
